export class User {
  avatar?: string;
  status?: string;

  id: string;
  userName: string;
  fio: string;
  mainRole: string;
  roles: string[];
  email: string;
  dateLastEnter: string;
  userAdd: string;
  countEnter: number;
  dateLastActive: string;

  surname: string;
  name: string;
  patronymic: string;

  token?: string;
  isChangePassword: boolean = false;
  password: string;
  passwordS: string;
  passwordOld: string;

  mainPositionId: string;
  positions: any;
  spInstitutionId: number;
  spInstitution: string;

  // tbStaffId: string;
  pinfl: string;
  tbStaffFIO: string;
  imageFileId?: number;
  tbFileImageBase64: string;
  expiration: Date;

  passportSeries?: string;
  passportNumber?: string;
  base64String?: string;
  birthDate?: Date;
  spGenderId?: string;
}
